'use strict'
/*
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var unitas = unitas || {}

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    svg4everybody() // Fix SVG spritemap in IE/Edge
  })

  document.addEventListener('gform_page_loaded', function (event) {
    // Select all "Next" buttons within form page footers
    const nextButtons = document.querySelectorAll(
      '.gform_page_footer .gform_next_button'
    )

    // Iterate through all found buttons and add the custom class
    nextButtons.forEach((button) => {
      button.classList.add('btn')
    })
  })

  // Components
  unitas.testimonials.init()
  unitas.travelplan.init()
  unitas.themelisttravel.init()
  unitas.accommodation.init()
  unitas.list.init()
  unitas.popularslider.init()
  unitas.sitenavigation.init()
  unitas.mobilenavigation.init()
  unitas.herogallery.init()
  unitas.sidemodal.init()
  unitas.darkoverlay.init()
  unitas.search.init()
  unitas.filters.init()
  unitas.pagetravel.init()
  unitas.traveldescription.init()
  unitas.hotelsmap.init()
  unitas.getofferform.init()
  unitas.foldOutText.init()
  unitas.multipleForms.init()

  if (document.querySelector('.page-form')) {
    unitas.travelrequest.init()
  }
})
